import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";

export const submitFundingRequestToFunder = createAsyncThunk<
  void,
  { id: string; hasBeenSubmitted: boolean },
  { extra: Partial<Dependencies> }
>(
  "fundingRequests/submitFundingRequestToFunder",
  async ({ id, hasBeenSubmitted }: { id: string; hasBeenSubmitted: boolean }, { extra: { adminRepository } }) => {
    return adminRepository!.submitToFunder(id, { hasBeenSubmitted });
  },
);

export const resetSubmitFundingRequestToFunder = createAction("fundingRequests/resetSubmitFundingRequestToFunder");
